import ConnectedStorePage from "./ConnectedStorePage";
import ConnectedStorePageContent from "./ConnectedStorePageContent";
import ConnectedSubmit from "./ConnectedSubmit";

export { ConnectedStorePageContent, ConnectedSubmit };

export default ConnectedStorePage;
